/**
 * French interface texts. Key = the English text shown in English, value = the French text.
 * Keep every {placeholder} of the key. Words the team uses as they are: pax, BDR, NV°, V1, C / CC / X, Master.
 * Glossary: booking = réservation, pickup = prise en charge, vehicle = véhicule, van = van, guide = guide,
 * to place = à placer, lock = verrouiller, Direction = Direction, Office = Bureau.
 */
export const FR = {
    // ---------- Words and short labels ----------
    '(new)': '(nouveau)',
    '(you)': '(vous)',
    'AM': 'Matin',
    'PM': 'Après-midi',
    'Accept': 'Accepter',
    'Active': 'Actif',
    'Add': 'Ajouter',
    'Address': 'Adresse',
    'Adults': 'Adultes',
    'Afternoon': 'Après-midi',
    'afternoon': 'après-midi',
    'Agencies': 'Agences',
    'Agency': 'Agence',
    'agency': 'agence',
    'Agency reference': 'Référence agence',
    'alerts': 'alertes',
    'All day': 'Journée',
    'Allowed': 'Autorisé',
    'Any time': 'Toute la journée',
    'Attention': 'Attention',
    'Auto': 'Auto',
    'Auto-plan': 'Planif. auto',
    'auto-plan': 'planification auto',
    'See all the alerts of the day': 'Voir toutes les alertes du jour',
    '{n} alerts for V{v}': '{n} alertes pour V{v}',
    'Alerts for V{n}': 'Alertes de V{n}',
    'Alerts of the day': 'Alertes du jour',
    'Day': 'Journée',
    '{pax} pax booked, minimum {min} for the tour to run.': '{pax} pax réservés, minimum {min} pour que le tour parte.',
    '{pax} pax booked (no minimum).': '{pax} pax réservés (pas de minimum).',
    'Click to change for this day.': 'Cliquer pour modifier ce jour.',
    'min {n}': 'min {n}',
    'Time': 'Heure',
    'Pax': 'Pax',
    'Lang.': 'Langue',
    'Missing': 'Manquant',
    'Background of the language badge in Bookings and Planning.': 'Fond du badge de langue dans Réservations et Planning.',
    'To do': 'À faire',
    'Nothing to do for today and tomorrow.': "Rien à faire pour aujourd'hui et demain.",
    'Tomorrow: bookings not confirmed (CC) yet': 'Demain : réservations pas encore confirmées (CC)',
    'Today: bookings still to place': "Aujourd'hui : réservations encore à placer",
    'Tomorrow: bookings still to place': 'Demain : réservations encore à placer',
    'Today: vehicles without van or guide': "Aujourd'hui : véhicules sans van ou sans guide",
    'Tomorrow: vehicles without van or guide': 'Demain : véhicules sans van ou sans guide',
    'Tomorrow: BDR not made or out of date': 'Demain : BDR pas fait ou plus à jour',
    'Next 7 days: bookings missing information': '7 prochains jours : réservations incomplètes',
    'Bookings with the same group travel together.': 'Les réservations du même groupe voyagent ensemble.',
    'Drop-off address': 'Adresse de dépose',
    'Drop-off place': 'Lieu de dépose',
    'Expected time': 'Heure prévue',
    'Expected time (Prévu)': 'Heure prévue',
    'Flight or train': 'Vol ou train',
    'Flight or train checked': 'Vol ou train vérifié',
    'Group': 'Groupe',
    'No pickup or drop-off place': 'Pas de lieu de prise en charge ou de dépose',
    'Official time': 'Heure officielle',
    'Pickup address': 'Adresse de prise en charge',
    'The real time after checking the flight or train. Empty = the official time.': "L'heure réelle après vérification du vol ou du train. Vide = l'heure officielle.",
    'Time checked': 'Heure vérifiée',
    'no time': 'sans heure',
    '{ref} is a tour: {v} carries transfers only.': '{ref} est un tour : {v} ne fait que des transferts.',
    '{ref} is a transfer: put it in a transfer vehicle.': '{ref} est un transfert : mettez-le dans un véhicule de transferts.',
    '{v} at {time}: several pickup places.': '{v} à {time} : plusieurs lieux de prise en charge.',
    '{v} at {time}: {pax} pax for {seats} seats.': '{v} à {time} : {pax} pax pour {seats} places.',
    '{v}: only {n} min between the {a} and {b} trips.': '{v} : seulement {n} min entre les trajets de {a} et de {b}.',
    '1 trip': '1 trajet',
    'A vehicle for transfers only': 'Un véhicule pour les transferts uniquement',
    'Add transfer vehicle': 'Ajouter un véhicule transferts',
    'Every transfer is placed.': 'Tous les transferts sont placés.',
    'No transfer.': 'Aucun transfert.',
    'Today: transfers whose flight or train is not checked': "Aujourd'hui : transferts dont le vol ou le train n'est pas vérifié",
    'Tomorrow: transfers whose flight or train is not checked': "Demain : transferts dont le vol ou le train n'est pas vérifié",
    'Transfers': 'Transferts',
    'placed': 'placés',
    'transfers': 'transferts',
    '{n} to place': '{n} à placer',
    '{n} trips': '{n} trajets',
    'Clear': 'Vider',
    'clear the day': 'vider la journée',
    'Take the placed bookings out of their vehicles': 'Retirer les réservations placées de leurs véhicules',
    'Take the {n} placed bookings out of their vehicles? Locked bookings and locked vehicles stay. Vehicles keep their van and guide. BDRs already sent will be out of date. You can undo.': 'Retirer les {n} réservations placées de leurs véhicules ? Les réservations et véhicules verrouillés restent. Les véhicules gardent leur van et leur guide. Les BDR déjà envoyés ne seront plus à jour. Vous pouvez annuler.',
    '{n} bookings back in To place.': '{n} réservations remises dans À placer.',
    'Baby seats': 'Sièges bébé',
    'Base code': 'Code de base',
    'booking': 'réservation',
    'bookings': 'réservations',
    'Bookings': 'Réservations',
    'Boosters': 'Rehausseurs',
    'Brand': 'Marque',
    'brand': 'marque',
    'Brands': 'Marques',
    'C': 'C',
    'CC': 'CC',
    'Calendar': 'Calendrier',
    'Cancel': 'Annuler',
    'cancel': 'annulation',
    'Cancelled': 'Annulée',
    'cancelled': 'annulées',
    'Cancelled (X)': 'Annulées (X)',
    'Cancelled today': 'Annulé aujourd’hui',
    'Cash to collect': 'Espèces à encaisser',
    'Cash to collect (€)': 'Espèces à encaisser (€)',
    'Channel': 'Canal',
    'channel': 'canal',
    'Channels': 'Canaux',
    'Children': 'Enfants',
    'Choose…': 'Choisir…',
    'Client': 'Client',
    'Close': 'Fermer',
    'Code': 'Code',
    'Code on the BDR': 'Code sur le BDR',
    'Colour': 'Couleur',
    'Company name': 'Raison sociale',
    'Contact': 'Contact',
    'Copied': 'Copié',
    'Copy': 'Copier',
    'Copy the key': 'Copier la clé',
    'create': 'création',
    'created': 'créées',
    'Cruise': 'Croisière',
    'Cruise excursion': 'Excursion croisière',
    'Dark': 'Sombre',
    'Date': 'Date',
    'Deactivate': 'Désactiver',
    'deactivate': 'désactivation',
    'Departs from': 'Départ de',
    'Departure': 'Départ',
    'Direct': 'Direct',
    'Direction': 'Direction',
    'Discard': 'Abandonner',
    'Done': 'Terminé',
    'Email': 'E-mail',
    'empty': 'vide',
    'End': 'Fin',
    'Evening': 'Soir',
    'Explanation': 'Explication',
    'Extra / stand-by': 'Renfort / astreinte',
    'Family': 'Famille',
    'Featured': 'À la une',
    'Flag': 'Marqueur',
    'Flow': 'Flux',
    'Former user': 'Ancien utilisateur',
    'Full day': 'Journée',
    'Go to': 'Aller à',
    'Guaranteed': 'Garanti',
    'guide': 'guide',
    'Guides': 'Guides',
    'Guide…': 'Guide…',
    'Half day (any)': 'Demi-journée (quelconque)',
    'History': 'Historique',
    'Hotel': 'Hôtel',
    'hotel': 'hôtel',
    'Hotel (as written)': 'Hôtel (tel qu’écrit)',
    'Hotels': 'Hôtels',
    'Inactive': 'Inactif',
    'Information': 'Information',
    'invalid value': 'valeur non valide',
    'Itinerary': 'Itinéraire',
    'Key': 'Clé',
    'Language': 'Langue',
    'Expand the menu': 'Déplier le menu',
    'Collapse the menu': 'Replier le menu',
    'Switch to light mode': 'Passer en mode clair',
    'Switch to dark mode': 'Passer en mode sombre',
    'language': 'langue',
    'Languages': 'Langues',
    'Last 7 days': '7 derniers jours',
    'Last call': 'Dernier appel',
    'Last login': 'Dernière connexion',
    'Light': 'Clair',
    'Lists': 'Listes',
    'Loading…': 'Chargement…',
    'Locked': 'Verrouillée',
    'Log in': 'Se connecter',
    'Log out': 'Se déconnecter',
    'Logging in…': 'Connexion…',
    'Logo': 'Logo',
    'Main': 'Principal',
    'Master': 'Master',
    'missing': 'manquant',
    'missing info': 'infos manquantes',
    'Missing info': 'Infos manquantes',
    'Missing:': 'Manque :',
    'Model': 'Modèle',
    'month': 'mois',
    'Month': 'Mois',
    'More': 'Plus',
    'Morning': 'Matin',
    'Move to': 'Déplacer vers',
    'My account': 'Mon compte',
    'Name': 'Nom',
    'Never': 'Jamais',
    'new bookings': 'nouvelles réservations',
    'New key': 'Nouvelle clé',
    'Next': 'Suivant',
    'Next day': 'Jour suivant',
    'No': 'Non',
    'No booking': 'Aucune réservation',
    'No guide': 'Pas de guide',
    'No name': 'Sans nom',
    'No tour': 'Sans tour',
    'no tour': 'sans tour',
    'No tour.': 'Pas de tour.',
    'No van': 'Pas de van',
    'No-show': 'No-show',
    'None': 'Aucun',
    'Normal': 'Normal',
    'not CC': 'pas CC',
    'not CC yet': 'pas encore CC',
    'Not contacted': 'Pas contacté',
    'Not made yet': 'Pas encore fait',
    'Not placed': 'Non placées',
    'Notes': 'Notes',
    'OK': 'OK',
    'Office': 'Bureau',
    'Only for agency': 'Seulement pour l’agence',
    'Open': 'Ouverte',
    'Open booking': 'Ouvrir la réservation',
    'Open bookings': 'Ouvrir les réservations',
    'Order': 'Ordre',
    'Other spellings': 'Autres écritures',
    'OTA / platform': 'OTA / plateforme',
    'Passenger seats': 'Places passagers',
    'Passengers': 'Passagers',
    'Password': 'Mot de passe',
    'pax': 'pax',
    'Phone': 'Téléphone',
    'Phone line': 'Ligne téléphone',
    'Pickup place': 'Lieu de prise en charge',
    'Pickup point': 'Point de prise en charge',
    'Pickup time': 'Heure de prise en charge',
    'plan': 'planning',
    'Planning': 'Planning',
    'Planning rules': 'Règles de planning',
    'Plate': 'Immatriculation',
    'Previous': 'Précédent',
    'Previous day': 'Jour précédent',
    'Priority': 'Priorité',
    'Private': 'Privé',
    'Problem': 'Problème',
    'Question': 'Question',
    'Reactivate': 'Réactiver',
    'reactivate': 'réactivation',
    'refreshed': 'mises à jour',
    'Remove': 'Retirer',
    'Revoke': 'Révoquer',
    'Revoked': 'Révoquée',
    'Role': 'Rôle',
    'rule': 'règle',
    'Save': 'Enregistrer',
    'Saved.': 'Enregistré.',
    'Saving…': 'Enregistrement…',
    'Search': 'Rechercher',
    'Search bookings': 'Rechercher des réservations',
    'Search the list': 'Rechercher dans la liste',
    'seats': 'places',
    'Shared': 'Partagé',
    'Shift': 'Créneau',
    'Sold by': 'Vendu par',
    'Staff': 'Personnel',
    'Stamp and signature': 'Cachet et signature',
    'Start': 'Début',
    'Status': 'Statut',
    'Status:': 'Statut :',
    'Stops': 'Arrêts',
    'team edits kept': 'corrections de l’équipe gardées',
    'Theme': 'Thème',
    'This guide': 'Ce guide',
    'To place': 'À placer',
    'to place': 'à placer',
    'Today': 'Aujourd’hui',
    'Tomorrow': 'Demain',
    'Tour': 'Tour',
    'tour': 'tour',
    'Tour names': 'Noms de tours',
    'tour name': 'nom de tour',
    'Tour or family': 'Tour ou famille',
    'Tours': 'Tours',
    'Tours today': 'Tours du jour',
    'Town': 'Ville',
    'Transfer': 'Transfert',
    'Type': 'Type',
    'Typed by hand': 'Saisie à la main',
    'unchanged': 'inchangées',
    'Undo': 'Annuler l’action',
    'Unlock': 'Déverrouiller',
    'update': 'modification',
    'Users': 'Utilisateurs',
    'Van…': 'Van…',
    'vehicle': 'véhicule',
    'vehicles': 'véhicules',
    'Vehicles': 'Véhicules',
    'Vehicle at disposal': 'Véhicule à disposition',
    'View': 'Vue',
    'VIP': 'VIP',
    'Week': 'Semaine',
    'week': 'semaine',
    'With': 'Avec',
    'X · cancelled': 'X · annulée',
    'Year': 'Année',
    'Yes': 'Oui',
    // ---------- Months and days ----------
    'January': 'Janvier', 'February': 'Février', 'March': 'Mars', 'April': 'Avril', 'May': 'Mai', 'June': 'Juin',
    'July': 'Juillet', 'August': 'Août', 'September': 'Septembre', 'October': 'Octobre', 'November': 'Novembre', 'December': 'Décembre',
    'Mon': 'Lun', 'Tue': 'Mar', 'Wed': 'Mer', 'Thu': 'Jeu', 'Fri': 'Ven', 'Sat': 'Sam', 'Sun': 'Dim',
    // ---------- Lists: names, new and add ----------
    'Add agency': 'Ajouter une agence',
    'Add brand': 'Ajouter une marque',
    'Add channel': 'Ajouter un canal',
    'Add guide': 'Ajouter un guide',
    'Add hotel': 'Ajouter un hôtel',
    'Add language': 'Ajouter une langue',
    'Add rule': 'Ajouter une règle',
    'Add tour': 'Ajouter un tour',
    'Add tour name': 'Ajouter un nom de tour',
    'Add vehicle': 'Ajouter un véhicule',
    'New agency': 'Nouvelle agence',
    'New brand': 'Nouvelle marque',
    'New channel': 'Nouveau canal',
    'New guide': 'Nouveau guide',
    'New hotel': 'Nouvel hôtel',
    'New language': 'Nouvelle langue',
    'New rule': 'Nouvelle règle',
    'New tour': 'Nouveau tour',
    'New tour name': 'Nouveau nom de tour',
    'New vehicle': 'Nouveau véhicule',
    'Afternoon direction': 'Sens l’après-midi',
    'Morning direction': 'Sens le matin',
    'East (Monaco side)': 'Est (côté Monaco)',
    'West (Cannes side)': 'Ouest (côté Cannes)',
    'Minimum pax': 'Pax minimum',
    'Name or old code': 'Nom ou ancien code',
    'Needs a vehicle alone': 'Véhicule seul',
    'Sender emails or domains': 'E-mails ou domaines expéditeurs',
    'Every product the office can plan: shared and private tours, cruise excursions, transfers.': 'Tous les produits que le bureau peut planifier : tours partagés et privés, excursions croisière, transferts.',
    'Old codes and the words agencies use for a tour ("1/2 MONACO" is T2A). Imports read this list.': 'Anciens codes et mots utilisés par les agences pour un tour (« 1/2 MONACO » = T2A). Les imports lisent cette liste.',
    'Partners who send bookings by email or Excel. Their import layout is saved here later.': 'Partenaires qui envoient leurs réservations par e-mail ou Excel. Leur modèle d’import sera enregistré ici.',
    'Pickup addresses. A booking with a known hotel gets its address automatically.': 'Adresses de prise en charge. Une réservation avec un hôtel connu reçoit son adresse automatiquement.',
    'Same tours, vans and guides; the brand only labels the booking.': 'Mêmes tours, vans et guides ; la marque ne fait qu’identifier la réservation.',
    'The people who drive and guide. Who drove which van is recorded day by day on the planning board.': 'Les personnes qui conduisent et guident. Qui a conduit quel van est noté jour par jour sur le planning.',
    'The physical fleet, by plate. V1, V2… are the vans scheduled on a day: they are set on the planning board, not here.': 'La flotte réelle, par immatriculation. V1, V2… sont les vans du jour : ils se règlent sur le planning, pas ici.',
    'Tour languages. Anyone can add one when a booking needs it.': 'Langues des tours. Tout le monde peut en ajouter une quand une réservation en a besoin.',
    'Where a booking was sold. Anyone can add a new code when a new provider appears.': 'Où la réservation a été vendue. Tout le monde peut ajouter un code quand un nouveau fournisseur arrive.',
    'Which tours may share a vehicle on the same day. A tour code, or a family written FAMILY:NAME.': 'Quels tours peuvent partager un véhicule le même jour. Un code de tour, ou une famille écrite FAMILY:NOM.',
    'Below this number the departure is flagged (it can be changed for one day on the planning board).': 'En dessous de ce nombre, le départ est signalé (modifiable pour un jour sur le planning).',
    'Empty = valid for every source.': 'Vide = valable pour toutes les sources.',
    'Group used by the rules (T1, HALF, OTHER_FULL, PRIVATE).': 'Groupe utilisé par les règles (T1, HALF, OTHER_FULL, PRIVATE).',
    'Higher wins when two rules apply.': 'La plus haute l’emporte quand deux règles s’appliquent.',
    'Language codes, e.g. FR, EN.': 'Codes de langue, ex. FR, EN.',
    'Leave empty to print the code (Spanish prints SP).': 'Laisser vide pour imprimer le code (l’espagnol imprime SP).',
    'Names used by platforms or agencies for the same hotel.': 'Noms utilisés par les plateformes ou agences pour le même hôtel.',
    'Private and cruise tours never share a vehicle.': 'Les tours privés et croisière ne partagent jamais un véhicule.',
    'Same circuit in another shift (T2 for T2M and T2A).': 'Même circuit à un autre créneau (T2 pour T2M et T2A).',
    'Shown as a light background on the planning board and the bookings list. Similar tours share a colour.': 'Fond clair sur le planning et la liste des réservations. Les tours semblables ont la même couleur.',
    'Used to recognise their emails, e.g. carol-voyages.com.': 'Sert à reconnaître leurs e-mails, ex. carol-voyages.com.',
    'Where the guide waits, if not the hotel door.': 'Où le guide attend, si ce n’est pas devant l’hôtel.',
    'Separate with commas or spaces': 'Séparer par des virgules ou des espaces',
    'Show inactive ({n})': 'Afficher les inactifs ({n})',
    'Show {n} more': 'Afficher {n} de plus',
    '{n} shown': '{n} affichés',
    'Imported from 2026, not changed since.': 'Importé de 2026, pas modifié depuis.',
    'Only the direction can change this list.': 'Seule la direction peut modifier cette liste.',
    'Only the direction can add to this list.': 'Seule la direction peut ajouter à cette liste.',
    'Only the direction can deactivate or reactivate items.': 'Seule la direction peut désactiver ou réactiver.',
    // ---------- Login, password, account ----------
    'Access is temporarily unavailable. Your work is saved.': 'L’accès est momentanément indisponible. Votre travail est enregistré.',
    'At least {n} characters. A short sentence is easy to remember.': 'Au moins {n} caractères. Une petite phrase se retient facilement.',
    'Auto follows the day or night mode of your phone or computer.': 'Auto suit le mode jour ou nuit de votre téléphone ou ordinateur.',
    'Back to log in': 'Retour à la connexion',
    'Bingo App is locked': 'Bingo App est verrouillée',
    'Bingo App is locked.': 'Bingo App est verrouillée.',
    'Bingo App is locked for everyone else.': 'Bingo App est verrouillée pour tous les autres.',
    'Change password': 'Changer le mot de passe',
    'Choose your password': 'Choisissez votre mot de passe',
    'Could not change the password.': 'Impossible de changer le mot de passe.',
    'Could not save the password.': 'Impossible d’enregistrer le mot de passe.',
    'Current password': 'Mot de passe actuel',
    'Email or password is incorrect.': 'E-mail ou mot de passe incorrect.',
    'Forgot your password? Ask the direction for a new link.': 'Mot de passe oublié ? Demandez un nouveau lien à la direction.',
    'Hello {name}': 'Bonjour {name}',
    'Hide password': 'Masquer le mot de passe',
    'language, theme, password': 'langue, thème, mot de passe',
    'Login failed.': 'Échec de la connexion.',
    'Manage users': 'Gérer les utilisateurs',
    'New password': 'Nouveau mot de passe',
    'Only the screens change language. Tour names, hotels and notes stay as they are.': 'Seuls les écrans changent de langue. Les noms des tours, les hôtels et les notes restent tels quels.',
    'Password changed. Your other devices were logged out.': 'Mot de passe changé. Vos autres appareils ont été déconnectés.',
    'Please log in.': 'Veuillez vous connecter.',
    'Repeat the password': 'Répétez le mot de passe',
    'Save and log in': 'Enregistrer et se connecter',
    'Show password': 'Afficher le mot de passe',
    'The current password is incorrect.': 'Le mot de passe actuel est incorrect.',
    'The password is too long.': 'Le mot de passe est trop long.',
    'The password must have at least {n} characters.': 'Le mot de passe doit avoir au moins {n} caractères.',
    'The two passwords are different.': 'Les deux mots de passe sont différents.',
    'This account is not active.': 'Ce compte n’est pas actif.',
    'This link is incomplete. Open the full link you received.': 'Ce lien est incomplet. Ouvrez le lien complet reçu.',
    'This link is no longer valid. Ask the direction for a new one.': 'Ce lien n’est plus valable. Demandez-en un nouveau à la direction.',
    'Too many attempts. Try again in {n} minutes.': 'Trop de tentatives. Réessayez dans {n} minutes.',
    'Use at least {n} characters.': 'Utilisez au moins {n} caractères.',
    // ---------- Users ----------
    'Add a person': 'Ajouter une personne',
    'An account with this email already exists.': 'Un compte existe déjà avec cet e-mail.',
    'At least one active Direction account must remain.': 'Il doit rester au moins un compte Direction actif.',
    'Could not load the users.': 'Impossible de charger les utilisateurs.',
    'Cut access now?': 'Couper l’accès maintenant ?',
    'Deactivated people can no longer log in, and their names stay in the history. Nobody is ever deleted.': 'Les personnes désactivées ne peuvent plus se connecter et leur nom reste dans l’historique. Personne n’est jamais supprimé.',
    'Link for {name}': 'Lien pour {name}',
    'New password link': 'Nouveau lien de mot de passe',
    'Office plans the days. Direction can also manage users and the lists of tours, vans and guides.': 'Le Bureau planifie les journées. La Direction gère aussi les utilisateurs et les listes de tours, vans et guides.',
    'Reactivate this account first.': 'Réactivez d’abord ce compte.',
    'Role of {name}': 'Rôle de {name}',
    'Send this link to the person (WhatsApp or email). It works once. A first-access link lasts 72 hours; a reset link lasts 2 hours.': 'Envoyez ce lien à la personne (WhatsApp ou e-mail). Il ne fonctionne qu’une fois. Un lien de premier accès dure 72 heures ; un lien de réinitialisation, 2 heures.',
    'This account is protected and cannot be changed here.': 'Ce compte est protégé et ne peut pas être modifié ici.',
    'This account was changed by someone else. Reload and try again.': 'Ce compte a été modifié par quelqu’un d’autre. Rechargez et réessayez.',
    'User not found.': 'Utilisateur introuvable.',
    'Waiting for first login': 'En attente de première connexion',
    'Yes, deactivate': 'Oui, désactiver',
    '{n} active': '{n} actifs',
    // ---------- Home, missing info ----------
    'Back to bookings': 'Retour aux réservations',
    'booking to complete': 'réservation à compléter',
    'bookings to complete': 'réservations à compléter',
    'Bookings from today on with no pickup time, phone, hotel or tour. Nearest date first.': 'Réservations à partir d’aujourd’hui sans heure de prise en charge, téléphone, hôtel ou tour. Date la plus proche d’abord.',
    'Missing info · from today on': 'Infos manquantes · à partir d’aujourd’hui',
    'Nothing missing. Well done.': 'Rien ne manque. Bravo.',
    'Pickup time, phone, hotel or tour still empty.': 'Heure de prise en charge, téléphone, hôtel ou tour encore vide.',
    '{n} to complete': '{n} à compléter',
    // ---------- Calendar ----------
    'Week of {date}': 'Semaine du {date}',
    '{b} bookings · {p} pax this week. Click a day to open it.': '{b} réservations · {p} pax cette semaine. Cliquez sur un jour pour l’ouvrir.',
    '{b} bookings · {p} pax this month. Click a day to open it.': '{b} réservations · {p} pax ce mois-ci. Cliquez sur un jour pour l’ouvrir.',
    '{b} bookings · {p} pax this year. Click a day to open it.': '{b} réservations · {p} pax cette année. Cliquez sur un jour pour l’ouvrir.',
    '{m} missing info, {c} not CC': '{m} infos manquantes, {c} pas CC',
    '{n} bk': '{n} rés.',
    '{n} missing info': '{n} infos manquantes',
    'Ask for 400 days at most.': 'Demandez 400 jours au maximum.',
    'The end date is before the start date.': 'La date de fin est avant la date de début.',
    // ---------- Bookings ----------
    '1 booking': '1 réservation',
    '{n} bookings': '{n} réservations',
    'A booking needs at least 1 passenger.': 'Une réservation doit avoir au moins 1 passager.',
    'A reminder for the guide; never added up.': 'Un rappel pour le guide ; jamais additionné.',
    'Booking not found.': 'Réservation introuvable.',
    'C · contacted': 'C · contacté',
    'CC · confirmed': 'CC · confirmé',
    'Choose a tour…': 'Choisir un tour…',
    'Contacted: tap when confirmed (CC)': 'Contacté : touchez quand c’est confirmé (CC)',
    'Not contacted: tap when contacted (C)': 'Pas contacté : touchez quand c’est contacté (C)',
    'Confirmed: tap to clear the status': 'Confirmé : touchez pour effacer le statut',
    'Cancelled: open the booking to change it': 'Annulée : ouvrez la réservation pour la modifier',
    'Could not change the status.': 'Impossible de changer le statut.',
    'Could not save.': 'Impossible d’enregistrer.',
    'Create booking': 'Créer la réservation',
    'created it': 'l’a créée',
    'cancelled it': 'l’a annulée',
    'changed {fields}': 'a modifié {fields}',
    'First 50 results, nearest date first': '50 premiers résultats, date la plus proche d’abord',
    'From {source}': 'Depuis {source}',
    'Known hotel: address filled from the list.': 'Hôtel connu : adresse remplie depuis la liste.',
    'New booking': 'Nouvelle réservation',
    'No booking on this day.': 'Aucune réservation ce jour-là.',
    'No client name': 'Pas de nom de client',
    'No hotel or address': 'Pas d’hôtel ni d’adresse',
    'No phone': 'Pas de téléphone',
    'No pickup place': 'Pas de lieu de prise en charge',
    'No pickup time': 'Pas d’heure de prise en charge',
    'No tour chosen': 'Aucun tour choisi',
    'Not in the list: kept as written.': 'Pas dans la liste : gardé tel qu’écrit.',
    'Nothing found.': 'Rien trouvé.',
    'Platform says: {value}': 'La plateforme indique : {value}',
    'Search any date: client, phone, email, reference': 'Toutes les dates : client, téléphone, e-mail, référence',
    'Start typing the hotel name': 'Tapez le nom de l’hôtel',
    'This hotel does not exist.': 'Cet hôtel n’existe pas.',
    '{n} found, nearest date first': '{n} trouvées, date la plus proche d’abord',
    '{n} · not counted anywhere': '{n} · comptées nulle part',
    '{who} changed this booking meanwhile. The latest version is shown.': '{who} a modifié cette réservation entre-temps. La dernière version est affichée.',
    '€{n} to collect': '{n} € à encaisser',
    // ---------- Planning board ----------
    '1 booking placed.': '1 réservation placée.',
    '{n} bookings placed.': '{n} réservations placées.',
    '{n} skipped:': '{n} ignorées :',
    'Afternoon guide of V{n}': 'Guide de l’après-midi de V{n}',
    'Auto-plan proposal': 'Proposition de planification auto',
    'BDR of the day': 'BDR du jour',
    'BDR out of date': 'BDR à refaire',
    'Bookings to place: {n}. New vehicles: {v}.': 'Réservations à placer : {n}. Nouveaux véhicules : {v}.',
    'Connection lost. Moves are paused until it returns; nothing is lost.': 'Connexion perdue. Les déplacements sont en pause jusqu’à son retour ; rien n’est perdu.',
    'Departure cancelled today.': 'Départ annulé aujourd’hui.',
    'Drop bookings here.': 'Déposez des réservations ici.',
    'Everything is placed.': 'Tout est placé.',
    'Guide of V{n}': 'Guide de V{n}',
    'Its bookings stay as they are: move each one to another tour or cancel it.': 'Ses réservations restent telles quelles : déplacez chacune vers un autre tour ou annulez-la.',
    'Last changed by {who}.': 'Modifié en dernier par {who}.',
    'Last made {when}': 'Fait le {when}',
    'Lock V{n}': 'Verrouiller V{n}',
    'Lock V{n}: nothing goes in or out': 'Verrouiller V{n} : rien n’entre ni ne sort',
    'Lock in this vehicle': 'Verrouiller dans ce véhicule',
    'Lock {ref} in this vehicle': 'Verrouiller {ref} dans ce véhicule',
    'Locked bookings and vehicles are not touched. Nothing is saved until you accept.': 'Les réservations et véhicules verrouillés ne sont pas touchés. Rien n’est enregistré avant d’accepter.',
    'Minimum pax today': 'Pax minimum aujourd’hui',
    'Minimum {n}': 'Minimum {n}',
    'Minimum: a number from 1 to 60, or empty.': 'Minimum : un nombre de 1 à 60, ou vide.',
    'Move {ref}': 'Déplacer {ref}',
    'move {ref}': 'déplacement de {ref}',
    'move {ref} to new V{n}': 'déplacement de {ref} vers la nouvelle V{n}',
    'New vehicle (V{n})': 'Nouveau véhicule (V{n})',
    'No connection: moves are paused until it returns.': 'Pas de connexion : les déplacements sont en pause jusqu’à son retour.',
    'No vehicle left ({n} at most).': 'Plus de véhicule disponible ({n} au maximum).',
    'No vehicle yet. Click “Add vehicle” to start the day.': 'Pas encore de véhicule. Cliquez sur « Ajouter un véhicule » pour commencer la journée.',
    'Not on this day any more.': 'N’est plus sur ce jour.',
    'Nothing to undo': 'Rien à annuler',
    'Open a new V with this booking in it': 'Ouvrir une nouvelle V avec cette réservation',
    'Other guide in the afternoon': 'Autre guide l’après-midi',
    'Day sheet': 'Planning du jour',
    'To place ({n})': 'À placer ({n})',
    'Cancelled ({n})': 'Annulées ({n})',
    '1 vehicle': '1 véhicule',
    '{n} vehicles': '{n} véhicules',
    'Printed on {date} at {time} by {name}': 'Imprimé le {date} à {time} par {name}',
    'Every vehicle of the day on one list, to check and print (A4 landscape)': 'Tous les véhicules du jour sur une liste, à vérifier et imprimer (A4 paysage)',
    'Driver of the {time} trip of V{n}': 'Chauffeur du trajet de {time} de V{n}',
    'Place the booking in a vehicle before locking it.': 'Placez la réservation dans un véhicule avant de la verrouiller.',
    'Remove V{n}': 'Retirer V{n}',
    'Same guide all day': 'Même guide toute la journée',
    'Seats for this date only': 'Places pour cette date seulement',
    'Seats of V{n} today': 'Places de V{n} aujourd’hui',
    'Someone changed this tour for the day meanwhile. The latest version is shown.': 'Quelqu’un a modifié ce tour pour la journée entre-temps. La dernière version est affichée.',
    'Someone changed this trip meanwhile. The latest version is shown.': 'Quelqu’un a modifié ce trajet entre-temps. La dernière version est affichée.',
    'Observations (BDR)…': 'Observations (BDR)…',
    'Observations of the {time} trip of V{n}': 'Observations du trajet de {time} de V{n}',
    'Only a transfer vehicle changes driver from one trip to another.': 'Seul un véhicule de transfert change de chauffeur d’un trajet à l’autre.',
    'Unknown guide.': 'Guide inconnu.',
    'Take it out of the vehicle': 'La retirer du véhicule',
    'Tap a booking to move it here.': 'Touchez une réservation pour la déplacer ici.',
    'The BDR could not be made.': 'Le BDR n’a pas pu être fait.',
    'The move was not saved.': 'Le déplacement n’a pas été enregistré.',
    'This booking is locked in its vehicle.': 'Cette réservation est verrouillée dans son véhicule.',
    'This vehicle breaks a rule with this booking: see the list below the vehicle.': 'Ce véhicule enfreint une règle avec cette réservation : voir la liste sous le véhicule.',
    'This vehicle is not on the same day as the booking.': 'Ce véhicule n’est pas le même jour que la réservation.',
    'This vehicle of the day no longer exists.': 'Ce véhicule du jour n’existe plus.',
    'Undo done in part: {list}': 'Annulation en partie faite : {list}',
    'Undo {what}': 'Annuler : {what}',
    'Undone: {what}.': 'Annulé : {what}.',
    'Unlock {ref}': 'Déverrouiller {ref}',
    'Usual: {n}': 'Habituel : {n}',
    'Van of V{n}': 'Van de V{n}',
    'V{n} is locked: nothing goes in or out.': 'V{n} est verrouillée : rien n’entre ni ne sort.',
    'V{v} still has 1 booking. Move it first.': 'V{v} a encore 1 réservation. Déplacez-la d’abord.',
    'V{v} still has {n} bookings. Move them first.': 'V{v} a encore {n} réservations. Déplacez-les d’abord.',
    'A day has 99 vehicles at most.': 'Une journée a 99 véhicules au maximum.',
    '{n} pax': '{n} pax',
    '{n} pax added': '{n} pax ajoutés',
    '{n} pax booked today. These settings are for this date only.': '{n} pax réservés aujourd’hui. Ces réglages ne valent que pour cette date.',
    '{ref} was just moved to {where} by someone else.': '{ref} vient d’être déplacée vers {where} par quelqu’un d’autre.',
    '{ref} was placed meanwhile.': '{ref} a été placée entre-temps.',
    '{ref}, {pax} pax, {tour}. Enter to open. Space to pick up, arrows to move, space to drop.': '{ref}, {pax} pax, {tour}. Entrée pour ouvrir. Espace pour prendre, flèches pour déplacer, espace pour déposer.',
    '{tour} on {date}': '{tour} le {date}',
    '{tour} today': '{tour} aujourd’hui',
    '{who} changed V{n} meanwhile. The latest version is shown.': '{who} a modifié V{n} entre-temps. La dernière version est affichée.',
    // ---------- Planning rules (shared with the server) ----------
    '1 booking in {v} misses information.': '1 réservation de {v} est incomplète.',
    '{n} bookings in {v} miss information.': '{n} réservations de {v} sont incomplètes.',
    '{a} and {b} go opposite ways in the {part}.': '{a} et {b} partent dans des sens opposés le {part}.',
    '{a} and {b} never share a vehicle.': '{a} et {b} ne partagent jamais un véhicule.',
    '{a} and {b} run at the same time in {v}.': '{a} et {b} ont lieu en même temps dans {v}.',
    '{guide} does not speak {list}.': '{guide} ne parle pas {list}.',
    '{guide} is already in V{n}.': '{guide} est déjà dans V{n}.',
    '{guide} is already in V{n} in the {part}.': '{guide} est déjà dans V{n} le {part}.',
    '{plate} is already V{n}.': '{plate} est déjà V{n}.',
    '{plate}: the {time} trip of {v} falls during the tours of V{n} ({part}).': '{plate} : le trajet de {time} de {v} tombe pendant les tours de V{n} ({part}).',
    '{guide} drives V{a} at {x} and V{b} at {y}.': '{guide} conduit V{a} à {x} et V{b} à {y}.',
    'This van': 'Ce van',
    '{ref} is cancelled and cannot be in a vehicle.': '{ref} est annulée et ne peut pas être dans un véhicule.',
    '{ref} is locked. Unlock it first.': '{ref} est verrouillée. Déverrouillez d’abord.',
    '{ref}: {pax} pax, more than any vehicle. Split it.': '{ref} : {pax} pax, plus que n’importe quel véhicule. À diviser.',
    '{tour} ({ref}) needs {v} alone.': '{tour} ({ref}) doit avoir {v} pour lui seul.',
    '{tour} cancelled today: 1 booking to move to another tour or cancel.': '{tour} annulé aujourd’hui : 1 réservation à déplacer vers un autre tour ou à annuler.',
    '{tour} cancelled today: {n} bookings to move to another tour or cancel.': '{tour} annulé aujourd’hui : {n} réservations à déplacer vers un autre tour ou à annuler.',
    '{tour} does not run today: take this booking out of {v}.': '{tour} ne part pas aujourd’hui : retirez cette réservation de {v}.',
    '{tour} does not run today: take these bookings out of {v}.': '{tour} ne part pas aujourd’hui : retirez ces réservations de {v}.',
    '{tour}: {pax} pax, minimum {min}. Guarantee or cancel.': '{tour} : {pax} pax, minimum {min}. Garantir ou annuler.',
    '{v} has no guide yet.': '{v} n’a pas encore de guide.',
    '{v} has no van yet.': '{v} n’a pas encore de van.',
    '{v} mixes {n} languages ({list}).': '{v} mélange {n} langues ({list}).',
    '{v} {part}: {pax} pax for {seats} seats.': '{v} {part} : {pax} pax pour {seats} places.',
    // ---------- Master: lock, history, n8n, BDR settings, import ----------
    'App 2026 file checked': 'Fichier App 2026 vérifié',
    'App 2026 history imported': 'Historique App 2026 importé',
    'App 2026 import stopped': 'Import App 2026 arrêté',
    'App locked': 'App verrouillée',
    'App unlocked': 'App déverrouillée',
    'Change lock password': 'Changer le mot de passe de verrouillage',
    'Choose a lock password first.': 'Choisissez d’abord un mot de passe de verrouillage.',
    'Choose a new lock password (link from the e-mail).': 'Choisissez un nouveau mot de passe de verrouillage (lien de l’e-mail).',
    'Current lock password': 'Mot de passe de verrouillage actuel',
    'E-mail is not set up on the server yet. Use the emergency reset in the server settings.': 'L’e-mail n’est pas encore configuré sur le serveur. Utilisez la réinitialisation d’urgence dans les réglages du serveur.',
    'E-mail sent to {to}. The link works for 30 minutes.': 'E-mail envoyé à {to}. Le lien est valable 30 minutes.',
    'First, choose a lock password.': 'D’abord, choisissez un mot de passe de verrouillage.',
    'Forgot the lock password?': 'Mot de passe de verrouillage oublié ?',
    'Lock password (not your log in password)': 'Mot de passe de verrouillage (pas celui de connexion)',
    'Lock password changed': 'Mot de passe de verrouillage changé',
    'Lock password chosen': 'Mot de passe de verrouillage choisi',
    'Lock password reset from the e-mail link': 'Mot de passe de verrouillage réinitialisé par le lien e-mail',
    'Lock password saved. Keep it somewhere safe: nobody else can unlock the app.': 'Mot de passe de verrouillage enregistré. Gardez-le en lieu sûr : personne d’autre ne peut déverrouiller l’app.',
    'Lock reset from the server settings': 'Verrouillage réinitialisé depuis les réglages du serveur',
    'Lock the app for everyone': 'Verrouiller l’app pour tout le monde',
    'Locked since {when}': 'Verrouillée depuis le {when}',
    'Master history': 'Historique Master',
    'Master lock': 'Verrou Master',
    'New lock password (only for locking; different from your log in password)': 'Nouveau mot de passe de verrouillage (seulement pour verrouiller ; différent de celui de connexion)',
    'New lock password saved.': 'Nouveau mot de passe de verrouillage enregistré.',
    'Nothing yet.': 'Rien pour l’instant.',
    'Only you see this. Locking stops everyone else at once; only you can unlock.': 'Vous seul voyez ceci. Verrouiller arrête tout le monde aussitôt ; vous seul pouvez déverrouiller.',
    'Password you use to log in': 'Mot de passe de connexion',
    'Reset e-mail sent': 'E-mail de réinitialisation envoyé',
    'Save lock password': 'Enregistrer le mot de passe de verrouillage',
    'Save new lock password': 'Enregistrer le nouveau mot de passe de verrouillage',
    'Something went wrong.': 'Une erreur est survenue.',
    'The app is locked. Only you can use it now.': 'L’app est verrouillée. Vous seul pouvez l’utiliser maintenant.',
    'The app is unlocked. Everyone can work again.': 'L’app est déverrouillée. Tout le monde peut travailler à nouveau.',
    'The e-mail could not be sent. Try again later, or use the emergency reset in the server settings.': 'L’e-mail n’a pas pu être envoyé. Réessayez plus tard ou utilisez la réinitialisation d’urgence dans les réglages du serveur.',
    'The emergency reset is on in the server settings (OWNER_LOCK_RESET). Turn it off, then choose a new lock password.': 'La réinitialisation d’urgence est active dans les réglages du serveur (OWNER_LOCK_RESET). Désactivez-la, puis choisissez un nouveau mot de passe de verrouillage.',
    'The lock password is incorrect.': 'Le mot de passe de verrouillage est incorrect.',
    'The lock password must be different from your login password.': 'Le mot de passe de verrouillage doit être différent de celui de connexion.',
    'The lock password must have at least {n} characters.': 'Le mot de passe de verrouillage doit avoir au moins {n} caractères.',
    'This link is no longer valid. Ask for a new e-mail.': 'Ce lien n’est plus valable. Demandez un nouvel e-mail.',
    'Too many wrong lock passwords. Try again in {n} minutes.': 'Trop de mots de passe de verrouillage erronés. Réessayez dans {n} minutes.',
    'Unlock the app': 'Déverrouiller l’app',
    'Wrong lock password': 'Mauvais mot de passe de verrouillage',
    'Wrong lock password: blocked 15 minutes': 'Mauvais mot de passe de verrouillage : bloqué 15 minutes',
    'Your login password is incorrect.': 'Votre mot de passe de connexion est incorrect.',
    'Bookings keep arriving while the app is locked.': 'Les réservations continuent d’arriver pendant que l’app est verrouillée.',
    'Copy it now: it will never be shown again. Paste it only in n8n, never in a chat or an e-mail.': 'Copiez-la maintenant : elle ne sera plus jamais affichée. Collez-la seulement dans n8n, jamais dans une discussion ou un e-mail.',
    'Could not create the key.': 'Impossible de créer la clé.',
    'Could not load the keys.': 'Impossible de charger les clés.',
    'Could not revoke the key.': 'Impossible de révoquer la clé.',
    'Create the key': 'Créer la clé',
    'e.g. BOKUN - BINGO': 'ex. BOKUN - BINGO',
    'Integrations (n8n)': 'Intégrations (n8n)',
    'Key for {name}': 'Clé pour {name}',
    'Missing integration key.': 'Clé d’intégration manquante.',
    'n8n key created': 'Clé n8n créée',
    'n8n key revoked': 'Clé n8n révoquée',
    'Name of the flow': 'Nom du flux',
    'No key yet.': 'Pas encore de clé.',
    'One key per n8n flow. The flow sends each booking to this address with its key:': 'Une clé par flux n8n. Le flux envoie chaque réservation à cette adresse avec sa clé :',
    'The flow will be refused at once.': 'Le flux sera refusé aussitôt.',
    'This key does not exist or is already revoked.': 'Cette clé n’existe pas ou est déjà révoquée.',
    'Unknown or revoked integration key.': 'Clé d’intégration inconnue ou révoquée.',
    'Yes, revoke': 'Oui, révoquer',
    '{a} new · {b} updated · {c} same · {d} skipped': '{a} nouvelles · {b} mises à jour · {c} identiques · {d} ignorées',
    '{n} errors': '{n} erreurs',
    'Add (PNG or JPEG)': 'Ajouter (PNG ou JPEG)',
    'Replace (PNG or JPEG)': 'Remplacer (PNG ou JPEG)',
    'BDR settings': 'Réglages BDR',
    'Company block, logo and stamp printed on every BDR: BINGO TOUR SASU runs all the vans, for both brands.': 'Bloc société, logo et cachet imprimés sur chaque BDR : BINGO TOUR SASU exploite tous les vans, pour les deux marques.',
    'Could not load the settings.': 'Impossible de charger les réglages.',
    'Legal line (SIRET, VAT)': 'Mentions légales (SIRET, TVA)',
    'No image.': 'Pas d’image.',
    'Save the company name first, then add the logo and the stamp.': 'Enregistrez d’abord la raison sociale, puis ajoutez le logo et le cachet.',
    'Save the company name of this brand first.': 'Enregistrez d’abord la raison sociale de cette marque.',
    'Send a PNG or JPEG image (2 MB at most).': 'Envoyez une image PNG ou JPEG (2 Mo au maximum).',
    'Someone changed these settings meanwhile. The latest version is shown.': 'Quelqu’un a modifié ces réglages entre-temps. La dernière version est affichée.',
    'The image is larger than 2 MB.': 'L’image dépasse 2 Mo.',
    'The image was not saved.': 'L’image n’a pas été enregistrée.',
    'already here (refreshed, your edits kept)': 'déjà présentes (mises à jour, vos corrections gardées)',
    'An import is running. Wait until it ends.': 'Un import est en cours. Attendez qu’il se termine.',
    'Channel codes not in Lists': 'Codes de canal absents des Listes',
    'Choose the backup file bingo-YYYYMMDD.db. A big file is faster to send compressed: right click on it, Send to › Compressed (zipped) folder, then choose the .zip here.': 'Choisissez le fichier de sauvegarde bingo-AAAAMMJJ.db. Un gros fichier part plus vite compressé : clic droit dessus, Envoyer vers › Dossier compressé, puis choisissez le .zip ici.',
    'Choose the file': 'Choisir le fichier',
    'duplicates in the file (newest kept)': 'doublons dans le fichier (le plus récent gardé)',
    'Import finished': 'Import terminé',
    'Import history from Bingo App 2026': 'Importer l’historique de Bingo App 2026',
    'Import stopped': 'Import arrêté',
    'Import {n} bookings': 'Importer {n} réservations',
    'Importing…': 'Import en cours…',
    'No database file was found in this zip.': 'Aucun fichier de base de données dans ce zip.',
    'No import is running.': 'Aucun import en cours.',
    'Nothing is imported yet: you first see the numbers and confirm.': 'Rien n’est encore importé : vous voyez d’abord les chiffres, puis vous confirmez.',
    'Open the calendar': 'Ouvrir le calendrier',
    'Reading the file…': 'Lecture du fichier…',
    'Send another file': 'Envoyer un autre fichier',
    'Send the file itself.': 'Envoyez le fichier lui-même.',
    'Sending… {n}%': 'Envoi… {n} %',
    'skipped (no valid date)': 'ignorées (pas de date valide)',
    'The file could not be sent.': 'Le fichier n’a pas pu être envoyé.',
    'The file goes straight to your server and is deleted after the import.': 'Le fichier va directement sur votre serveur et est supprimé après l’import.',
    'The file is empty.': 'Le fichier est vide.',
    'The import could not start.': 'L’import n’a pas pu démarrer.',
    'The {n} transfers are not imported yet: they come with the transfers module.': 'Les {n} transferts ne sont pas encore importés : ils viendront avec le module transferts.',
    'These bookings are imported anyway. Codes not found in Lists stay empty; add them in Lists and send the file again to fill them.': 'Ces réservations sont importées quand même. Les codes absents des Listes restent vides ; ajoutez-les dans les Listes et renvoyez le fichier pour les remplir.',
    'This file could not be read as a Bingo App 2026 database.': 'Ce fichier n’a pas pu être lu comme une base Bingo App 2026.',
    'This file has no bookings table: it is not a Bingo App 2026 database.': 'Ce fichier n’a pas de table des réservations : ce n’est pas une base Bingo App 2026.',
    'This file has no usable bookings table.': 'Ce fichier n’a pas de table des réservations utilisable.',
    'This file is larger than 2 GB. Send it compressed (.zip) instead.': 'Ce fichier dépasse 2 Go. Envoyez-le compressé (.zip).',
    'This file is no longer here. Send it again.': 'Ce fichier n’est plus là. Renvoyez-le.',
    'This file is not a Bingo App 2026 database (bingo.db).': 'Ce fichier n’est pas une base Bingo App 2026 (bingo.db).',
    'This file was already imported. Send it again to import once more.': 'Ce fichier a déjà été importé. Renvoyez-le pour l’importer à nouveau.',
    'This zip file could not be opened.': 'Ce fichier zip n’a pas pu être ouvert.',
    'This zip file could not be read.': 'Ce fichier zip n’a pas pu être lu.',
    'To check after the import': 'À vérifier après l’import',
    'Tour codes not in Lists': 'Codes de tour absents des Listes',
    'Unusual languages': 'Langues inhabituelles',
    'What the file contains': 'Ce que contient le fichier',
    'The platform product list ({n} lines) is copied too: it tells which tour each Bokun or Bookingkit product is.': 'La liste des produits des plateformes ({n} lignes) est copiée aussi : elle indique quel tour correspond à chaque produit Bokun ou Bookingkit.',
    'Hotels recognised from the list: {a} of {b}. The others keep the hotel as written.': 'Hôtels reconnus dans la liste : {a} sur {b}. Les autres gardent l’hôtel tel qu’écrit.',
    '{a} of {b}. You can leave this page; the import continues.': '{a} sur {b}. Vous pouvez quitter cette page ; l’import continue.',
    '{n} bookings above 99 passengers (set to 99).': '{n} réservations au-dessus de 99 passagers (ramenées à 99).',
    '{n} bookings with 0 passengers.': '{n} réservations avec 0 passager.',
    // ---------- Server and connection errors ----------
    'A linked item does not exist.': 'Un élément lié n’existe pas.',
    'booking is missing.': 'la réservation manque.',
    'No connection to the server. Check the internet and try again.': 'Pas de connexion au serveur. Vérifiez internet et réessayez.',
    'Not found.': 'Introuvable.',
    'Request failed ({n}).': 'La demande a échoué ({n}).',
    'Request refused.': 'Demande refusée.',
    'Someone changed this item meanwhile. Reload and try again.': 'Quelqu’un a modifié cet élément entre-temps. Rechargez et réessayez.',
    'Something went wrong on the server.': 'Une erreur est survenue sur le serveur.',
    'This item does not exist.': 'Cet élément n’existe pas.',
    'This value is already used by another item.': 'Cette valeur est déjà utilisée par un autre élément.',
    'Too many requests. Wait a minute.': 'Trop de demandes. Attendez une minute.',
    'Unknown API route.': 'Adresse d’API inconnue.',
    'Unknown action "{action}".': 'Action inconnue « {action} ».',
    'Upload failed ({n}).': 'L’envoi a échoué ({n}).',
    'You do not have access to this.': 'Vous n’avez pas accès à ceci.',
    '{field}: {problem}': '{field} : {problem}',
    // ---------- Names in other alphabets ----------
    'Name in Latin letters': 'Nom en lettres latines',
    'Filled in automatically after saving': 'Rempli automatiquement après l’enregistrement',
    'Shown on the screens and the BDR. Written automatically from the name; a correction made here is kept.': 'Affiché sur les écrans et le BDR. Écrit automatiquement à partir du nom ; une correction faite ici est gardée.',
    // ---------- Transfers page (0.25) ----------
    '1 transfer': '1 transfert',
    '{n} transfers': '{n} transferts',
    '{n} placed': '{n} placés',
    'Checked': 'Vérifié',
    'Driver of V{n}': 'Chauffeur de V{n}',
    'Driver…': 'Chauffeur…',
    'Expected (Prévu)': 'Prévu',
    'Expected {exp} (official {off})': 'Prévu {exp} (officiel {off})',
    'From': 'De',
    'To': 'À',
    'Service': 'Service',
    'No transfer vehicle yet. Click “Add transfer vehicle” to start.': 'Aucun véhicule transfert. Cliquez sur « Ajouter un véhicule transferts » pour commencer.',
    'Open Transfers': 'Ouvrir Transferts',
    'Prévu: the time after checking the flight or train; empty = the official time.': 'Prévu : l’heure après vérification du vol ou du train ; vide = l’heure officielle.',
    'Today: transfer vehicles without van or driver': 'Aujourd’hui : véhicules transfert sans van ou chauffeur',
    'Tomorrow: transfer vehicles without van or driver': 'Demain : véhicules transfert sans van ou chauffeur',
    'Today: transfers still to place': 'Aujourd’hui : transferts encore à placer',
    'Tomorrow: transfers still to place': 'Demain : transferts encore à placer',
    '{pax} of {seats} seats': '{pax} sur {seats} places',
    '+{n} more': '+{n} autres',
    '1 to place': '1 à placer',
    'Ask for 62 days at most.': 'Demandez 62 jours au maximum.',
    'Open this day': 'Ouvrir ce jour',
    'TRANSFER': 'TRANSFERT',
    'updated': 'mises à jour',
    'platform products copied': 'produits des plateformes copiés',
    'seconds': 'secondes',
    'done': 'faites',
    'Lost-booking watch run by hand': 'Contrôle des réservations perdues lancé à la main',
    'Welcome signs': 'Pancartes d’accueil',
    'One A4 sign per arriving client, with the logo of the booking’s brand': 'Une pancarte A4 par client à l’arrivée, avec le logo de la marque de la réservation',
    'For this brand only the logo is used: on the welcome signs of its clients. The BDR always carries the BINGO TOUR SASU block.': 'Pour cette marque, seul le logo sert : sur les pancartes d’accueil de ses clients. Le BDR porte toujours le bloc BINGO TOUR SASU.',
    'Previous week': 'Semaine précédente',
    'Next week': 'Semaine suivante',
    'New booking · copy of {ref}': 'Nouvelle réservation · copie de {ref}',
    'Copy of {ref}: the client is copied; choose the service, the route and the times. Nothing is saved before Create.': 'Copie de {ref} : le client est copié ; choisissez le service, le trajet et les horaires. Rien n’est enregistré avant Créer.',
    'Copy of {ref}: check the date. Nothing is saved before Create.': 'Copie de {ref} : vérifiez la date. Rien n’est enregistré avant Créer.',
    'The copy is typed by hand (not linked to the platform), not contacted, and to place.': 'La copie est saisie à la main (non liée à la plateforme), non contactée, et à placer.',
    'Opens a new booking filled from this one; nothing is saved before Create': 'Ouvre une nouvelle réservation remplie à partir de celle-ci ; rien n’est enregistré avant Créer',
    'Duplicate': 'Dupliquer',
    'created it as a copy of {ref}': 'l’a créée comme copie de {ref}',
    'copied it as {ref}': 'l’a copiée en {ref}',
    'The booking to copy no longer exists.': 'La réservation à copier n’existe plus.',
    'DD/MM/YYYY': 'JJ/MM/AAAA',
    'HH:MM': 'HH:MM',
    'This booking has changes that are not saved. Discard them?': 'Cette réservation a des modifications non enregistrées. Les abandonner ?',
    'Platform': 'Plateforme',
    'received it from the booking platform': 'l’a reçue de la plateforme de réservation',
    'imported it from Bingo App 2026': 'l’a importée de Bingo App 2026',
    'locked it in its vehicle': 'l’a verrouillée dans son véhicule',
    'unlocked it': 'l’a déverrouillée',
    'moved it: {from} → {to}': 'l’a déplacée : {from} → {to}',
    'new transfers': 'nouveaux transferts',
    'already here (only empty fields filled)': 'déjà ici (seuls les champs vides sont remplis)',
    'from today on, not cancelled': 'à partir d’aujourd’hui, non annulés',
    '{n} transfers have a route that is not a product: they are imported as "TR" with their From and To places as written.': '{n} transferts ont un trajet qui n’est pas un produit : ils sont importés en « TR » avec leurs lieux De et À tels qu’écrits.',
    'transfer is missing.': 'le transfert manque.',
};
//# sourceMappingURL=fr.js.map